// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Help_container__C4iS1 {
  padding-top: 124px;
  width: 50%;
}
.Help_container__C4iS1 .Help_wrapper__qN2gl {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3019607843);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  padding-top: 125px;
  padding-bottom: 125px;
}
.Help_container__C4iS1 .Help_wrapper__qN2gl .Help_content__RPwCJ {
  text-align: center;
  width: 55%;
}
.Help_container__C4iS1 .Help_wrapper__qN2gl .Help_content__RPwCJ .Help_title__LP171 {
  font-size: 48px;
  font-weight: 700;
  font-style: normal;
  color: #ffffff;
  font-size: 40px;
  margin-bottom: 24px;
}
.Help_container__C4iS1 .Help_wrapper__qN2gl .Help_content__RPwCJ .Help_info__L1PBS {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
}
.Help_container__C4iS1 .Help_wrapper__qN2gl .Help_content__RPwCJ .Help_help__cSmIE {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-top: 24px;
}
.Help_container__C4iS1 .Help_wrapper__qN2gl .Help_content__RPwCJ .Help_help__cSmIE .Help_tg__q\\+E9q {
  align-items: center;
  background-color: #19334f;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  height: 76px;
  transition: all 0.2s linear;
  width: 100px;
}
.Help_container__C4iS1 .Help_wrapper__qN2gl .Help_content__RPwCJ .Help_help__cSmIE .Help_tg__q\\+E9q:hover {
  background-color: #244971;
}
.Help_container__C4iS1 .Help_wrapper__qN2gl .Help_content__RPwCJ .Help_help__cSmIE .Help_phone__znnER {
  align-items: center;
  background-color: #3a2159;
  border-radius: 8px;
  color: #ae6fff;
  display: flex;
  gap: 8px;
  justify-content: center;
  height: 76px;
  transition: all 0.2s linear;
  width: auto;
}
.Help_container__C4iS1 .Help_wrapper__qN2gl .Help_content__RPwCJ .Help_help__cSmIE .Help_phone__znnER:hover {
  background-color: #4a2c6f;
}

@media (max-width: 1100px) {
  .Help_container__C4iS1 {
    padding-top: 104px;
    width: 90%;
  }
}
@media (max-width: 850px) {
  .Help_container__C4iS1 .Help_wrapper__qN2gl {
    padding-bottom: 20px;
    padding-top: 20px;
  }
}
@media (max-width: 600px) {
  .Help_container__C4iS1 .Help_wrapper__qN2gl .Help_content__RPwCJ {
    padding-left: 34px;
    padding-right: 34px;
    width: 100%;
  }
  .Help_container__C4iS1 .Help_wrapper__qN2gl .Help_content__RPwCJ .Help_title__LP171 {
    font-size: 32px;
    font-weight: 700;
    font-style: normal;
  }
  .Help_container__C4iS1 .Help_wrapper__qN2gl .Help_content__RPwCJ .Help_info__L1PBS {
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Help/Help.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,UAAA;AADF;AAGE;EACE,mBAAA;EACA,6CAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;AADJ;AAGI;EACE,kBAAA;EACA,UAAA;AADN;AAGM;ECZJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDaM,cEtBE;EFuBF,eAAA;EACA,mBAAA;AAAR;AAGM;ECgBJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDfM,cExBO;AFwBf;AAGM;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;AADR;AAGQ;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,YAAA;AADV;AAGU;EACE,yBAAA;AADZ;AAKQ;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,WAAA;AAHV;AAKU;EACE,yBAAA;AAHZ;;AAWA;EACE;IACE,kBAAA;IACA,UAAA;EARF;AACF;AAgBA;EAEI;IACE,oBAAA;IACA,iBAAA;EAfJ;AACF;AAsBA;EAGM;IACE,kBAAA;IACA,mBAAA;IACA,WAAA;EAtBN;EAwBM;IC9FN,eAAA;IACA,gBAAA;IACA,kBAAA;EDyEA;EAuBM;IClDN,eAAA;IACA,gBAAA;IACA,kBAAA;ED8BA;AACF","sourcesContent":["@import \"../../assets/styles/global.scss\";\n\n.container {\n  padding-top: 124px;\n  width: 50%;\n\n  .wrapper {\n    align-items: center;\n    background-color: #0000004d;\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n    padding-top: 125px;\n    padding-bottom: 125px;\n\n    .content {\n      text-align: center;\n      width: 55%;\n\n      .title {\n        @include h2;\n\n        color: $c-white;\n        font-size: 40px;\n        margin-bottom: 24px;\n      }\n\n      .info {\n        @include subtitle5;\n\n        color: $c-light-grey;\n      }\n\n      .help {\n        display: flex;\n        gap: 20px;\n        justify-content: center;\n        margin-top: 24px;\n\n        .tg {\n          align-items: center;\n          background-color: #19334f;\n          border-radius: 8px;\n          display: flex;\n          justify-content: center;\n          height: 76px;\n          transition: all 0.2s linear;\n          width: 100px;\n\n          &:hover {\n            background-color: #244971;\n          }\n        }\n\n        .phone {\n          align-items: center;\n          background-color: #3a2159;\n          border-radius: 8px;\n          color: #ae6fff;\n          display: flex;\n          gap: 8px;\n          justify-content: center;\n          height: 76px;\n          transition: all 0.2s linear;\n          width: auto;\n\n          &:hover {\n            background-color: #4a2c6f;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1100px) {\n  .container {\n    padding-top: 104px;\n    width: 90%;\n\n    .wrapper {\n      .content {\n      }\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .container {\n    .wrapper {\n      padding-bottom: 20px;\n      padding-top: 20px;\n\n      .content {\n      }\n    }\n  }\n}\n\n@media (max-width: 600px) {\n  .container {\n    .wrapper {\n      .content {\n        padding-left: 34px;\n        padding-right: 34px;\n        width: 100%;\n\n        .title {\n          @include h3;\n        }\n\n        .info {\n          @include body1;\n        }\n      }\n    }\n  }\n}\n","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #FD4C0A;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Help_container__C4iS1`,
	"wrapper": `Help_wrapper__qN2gl`,
	"content": `Help_content__RPwCJ`,
	"title": `Help_title__LP171`,
	"info": `Help_info__L1PBS`,
	"help": `Help_help__cSmIE`,
	"tg": `Help_tg__q+E9q`,
	"phone": `Help_phone__znnER`
};
export default ___CSS_LOADER_EXPORT___;
